import { combineReducers } from "redux";
import sessionStorage from "redux-persist/lib/storage/session";
import { persistReducer } from "redux-persist";
import auth from "./auth";
import api from "../../apis/api";

const persistConfig = {
  key: "root",
  storage: sessionStorage,
  whiteList: ["auth"],
};

const rootReducer = combineReducers({
  auth,
  [api.reducerPath]: api.reducer,
});

export default persistReducer(persistConfig, rootReducer);
